import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import TeamImage from '@assets/images/placeholder/team-placeholder.svg'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import CustomLink from '@shared/components/customLink'

const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })
const MyImage = dynamic(() => import('@shared/components/myImage'))

function SeriesTeam({ data }) {
  const teams = data?.listSeriesTeams?.aTeams?.filter((data) => data?._id !== '622d96830961155e958ac6cf')

  return (
    <section>
      {data?.listSeriesTeams && (
        <>
          <Row className={`${styles.teamList}`}>
            {teams?.map((team) => {
              return (
                <Col key={team?._id} xxl={4} md={6} >
                  {team?.eTagStatus === 'p' ? <div className={`${styles.team} ${team?.eTagStatus === 'p' ? 'disabled' : ''} common-box d-flex align-items-center opacity-100 mb-2 mb-4`}>
                    <div className={`${styles.teamLogo} mx-auto flex-shrink-0`}>
                      <MyImage
                        src={team?.oImg?.sUrl ? `${S3_PREFIX}${team?.oImg?.sUrl}` : TeamImage}
                        errorImage={TeamImage}
                        alt={team?.sTitle}
                        width={40}
                        height={40}
                        layout="responsive"
                        autoRadiusImage
                      />
                    </div>
                    <div className="flex-grow-1">
                      <h5 className={`${styles.name} font-bold`}>{team?.sTitle}</h5>
                      {/* <CustomLink href={'/' + team?.oSeo?.sSlug || ''}>
                        <a className={`${styles.teamBtn} theme-btn small-btn ${team?.eTagStatus === 'p' ? 'disabled' : ''}`}>{"View Profile"}</a>
                        </Link> */}
                    </div>
                  </div> : <CustomLink href={'/' + team?.oSeo?.sSlug || ''} prefetch={false}>
                    <a className={`${styles.team} ${team?.eTagStatus === 'p' ? 'disabled' : ''} common-box d-flex align-items-center opacity-100 mb-2 mb-4`}>
                      <div className={`${styles.teamLogo} mx-auto flex-shrink-0`}>
                        <MyImage
                          src={team?.oImg?.sUrl ? `${S3_PREFIX}${team?.oImg?.sUrl}` : TeamImage}
                          errorImage={TeamImage}
                          alt={team?.sTitle}
                          width={40}
                          height={40}
                          layout="responsive"
                          autoRadiusImage
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h5 className={`${styles.name} font-bold`}>{team?.sTitle}</h5>
                        {/* <CustomLink href={'/' + team?.oSeo?.sSlug || ''}>
                        <a className={`${styles.teamBtn} theme-btn small-btn ${team?.eTagStatus === 'p' ? 'disabled' : ''}`}>{"View Profile"}</a>
                        </Link> */}
                      </div>
                    </a>
                  </CustomLink>}

                </Col>
              )
            })}
          </Row>
        </>
      )}
      {!data?.listSeriesTeams && <NoData />}
    </section>
  )
}
SeriesTeam.propTypes = {
  data: PropTypes.object
}

export default SeriesTeam
